import {
  ConversationData,
  ConversationStatusGroup,
} from '@zonofi/zono-money-store';
import React from 'react';
import { ConversationCard } from '../conversation-card/conversation-card';
import './conversation-list.scss';
import {
  EmptyStateView,
  EndListView,
  ListSkeleton,
  PullRefreshContainer,
  SpinnerLoader,
} from '../../components';
import { ConvervationModalVariant } from '../../types';
import { isEmpty } from 'lodash';
import { TagsKey } from '../contstants';
import { SVGS } from '../../assets';
import { FunnelGroupInfo } from '../../types';

interface ConversationListProps {
  data: ConversationData[];
  onActionPress: (payload: {
    action: ConvervationModalVariant;
    conversation: ConversationData;
  }) => void;
  onScroll: () => void;
  lastItemRef: React.MutableRefObject<HTMLDivElement | null>;
  isPageLoading: boolean;
  isLoading: boolean;
  findStatusCategory: (status: string) => ConversationStatusGroup;
  findTagType: (tag: string) => TagsKey;
  isEndOfList?: boolean;
  onRefresh?: () => void | Promise<void>;
  mergedFunnelGroupMap?: Record<string, FunnelGroupInfo>;
}

export const ConversationList: React.FC<ConversationListProps> = ({
  data,
  onActionPress,
  onScroll,
  lastItemRef,
  isLoading,
  isPageLoading,
  findStatusCategory,
  findTagType,
  isEndOfList,
  onRefresh,
  mergedFunnelGroupMap,
}) => {
  return (
    <PullRefreshContainer
      className="conversation-list"
      onScroll={onScroll}
      onRefresh={onRefresh}
    >
      {isLoading ? (
        <ListSkeleton />
      ) : isEmpty(data) ? (
        <EmptyStateView
          imageSrc={SVGS.NoConversation}
          message={'No conversations found'}
          description={'Try changing the date to view conversations.'}
        />
      ) : (
        <>
          {data.map((item) => (
            <ConversationCard
              key={item.conversationThreadId}
              {...item}
              funnelGroupMap={mergedFunnelGroupMap}
              onAssignTeamMember={() =>
                onActionPress({ action: 'assign', conversation: item })
              }
              onMoreAction={() =>
                onActionPress({ action: 'more', conversation: item })
              }
              onChangeLifecycle={() =>
                onActionPress({ action: 'lifecycle', conversation: item })
              }
              findStatusCategory={findStatusCategory}
              findTagType={findTagType}
            />
          ))}
          <div ref={lastItemRef} />
          {isPageLoading && <SpinnerLoader />}
          {isEndOfList && <EndListView />}
        </>
      )}
    </PullRefreshContainer>
  );
};
